module.exports = "mutation ($id: ID!) {\n  ResidentialDelete(id: $id) {\n    id\n  }\n}\n"